<app-mini-layout-wrapper xmlns="http://www.w3.org/1999/html" [showLogout]="iemService.isIcpViewInEm()">
  <div class="mini-layout__title">{{rebootTexts.title}}</div>
  <div class="mini-layout__text">{{rebootTexts.additionalText}}</div>

  <div class="g-margin-top-20">
    <app-loader></app-loader>
    <div *ngIf="ip$ | async as ipList" class="mini-layout-font-18 g-margin-top-30">
      {{ availableIpTexts }}
      <div class="g-margin-top-30">
        <div *ngFor="let ip of ipList">
          <strong> {{ip}}</strong>
        </div>
      </div>
    </div>
  </div>
</app-mini-layout-wrapper>
